import React from 'react'

const Container = ({ children, category }) => {
	return (
		<div>
			{children}
			<style jsx>{`
				div {
					display: grid;
					grid-template-columns: 20% 80%;
					grid-template-rows: ${category === 'Collaborator' ||
					category === 'Resources'
						? 'repeat(auto-fill)'
						: 'repeat(auto-fill)'};
					width: 100%;

					// cursor: pointer;
					position: relative;
				}
				@media only screen and (max-width: 768px), (pointer: coarse) {
					div {
						grid-template-columns: 100%;
					}
				}
			`}</style>
		</div>
	)
}

export default Container
